import React from 'react';
import PropTypes from 'prop-types';
import {
  Image,
} from 'framework-ui-components';
import { ConfirmModal } from 'framework-ui-components/Components/V2';
import dangerSvg from '../../../Content/images/danger.svg';
import infoSvg from '../../../Content/images/info.svg';

const Confirm = ({
  dangerous, ...props
}) => (
  <ConfirmModal
    show
    image={(
      <Image
        src={dangerous ? dangerSvg : infoSvg}
        alt={dangerous ? 'Attenzione' : 'Informazione'}
        title={dangerous ? 'Attenzione' : 'Informazione'}
      />
    )}
    initialPos={{ x: 'auto', y: 200 }}
    {...props}
  />
);

Confirm.propTypes = {
  dangerous: PropTypes.bool,
};

Confirm.defaultProps = {
  dangerous: false,
};

export default Confirm;
